export type CategoryType = 'movie' | 'tv' | 'variety';

export interface Movie {
  id: string;
  title: string;
  category: CategoryType;
  year: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  heat: number;
  duration: string;
  releaseDate: string;
  poster: string;
  banner?: string;
  synopsis: string;
  tags: string[];
}

export const CATEGORY_LABELS: Record<CategoryType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const CATEGORY_INTRO: Record<CategoryType, string> = {
  movie: '电影频道：最新大片与经典佳作一览',
  tv: '电视剧频道：口碑热剧与高分剧集精选',
  variety: '综艺频道：人气综艺与新季节目合集',
};

export const REGION_OPTIONS = ['全部', '中国大陆', '中国香港', '美国', '英国', '日本', '韩国', '法国'];

export const GENRE_OPTIONS: Record<CategoryType, string[]> = {
  movie: ['全部', '动作', '科幻', '爱情', '悬疑', '动画', '剧情', '喜剧'],
  tv: ['全部', '都市', '古装', '悬疑', '家庭', '历史', '爱情', '罪案'],
  variety: ['全部', '真人秀', '音乐', '竞技', '访谈', '生活', '喜剧', '文化'],
};

export const YEAR_OPTIONS = ['全部', '2026', '2025', '2024', '2023', '2022', '更早'];